import { Link } from "react-router-dom";
import { Instagram, Youtube, Twitter, Linkedin } from "lucide-react";
import { Logo } from "@/components/wei/Badges";

const COLS = [
  { title: "Platform", links: [["Registry", "/registry"], ["Rankings", "/rankings"], ["Verification", "/get-verified"], ["Events", "/events"], ["News", "/news"], ["Intelligence", "/intelligence"]] },
  { title: "Institute", links: [["About WEI", "/about"], ["Governance", "/about#governance"], ["Methodology", "/rankings#methodology"], ["Editorial Standards", "/about#editorial"], ["Verification Policy", "/get-verified#policy"], ["Corrections", "/about#corrections"], ["Contact", "/about#contact"]] },
  { title: "Legal", links: [["Privacy", "/about#privacy"], ["Terms", "/about#terms"], ["Cookies", "/about#cookies"]] },
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="container-wei py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Logo light size="lg" />
          <p className="text-sm text-white/60 mt-5 max-w-xs leading-relaxed">A global entertainment registry, professional verification, classification, rankings, editorial, events and entertainment-intelligence platform.</p>
          <div className="flex gap-3 mt-6">
            {[["instagram", Instagram], ["youtube", Youtube], ["twitter", Twitter], ["linkedin", Linkedin]].map(([k, I]) => <a key={k} href="#" aria-label="social" className="w-9 h-9 border border-white/20 rounded-sm inline-flex items-center justify-center text-white/70 hover:text-gold hover:border-gold transition-colors"><I className="w-4 h-4" /></a>)}
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <h4 className="eyebrow text-gold mb-4">{c.title}</h4>
            <ul className="space-y-2.5">{c.links.map(([l, to]) => <li key={l}><Link to={to} className="text-sm text-white/70 hover:text-white transition-colors">{l}</Link></li>)}</ul>
          </div>
        ))}
        <div className="md:col-span-2">
          <h4 className="eyebrow text-gold mb-4">Members</h4>
          <ul className="space-y-2.5">
            <li><Link to="/join" className="text-sm text-white/70 hover:text-white">Join WEI</Link></li>
            <li><Link to="/claim" className="text-sm text-white/70 hover:text-white">Claim a Profile</Link></li>
            <li><Link to="/dashboard" className="text-sm text-white/70 hover:text-white">Member Dashboard</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-wei py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="eyebrow text-white/50">Building the World's Entertainment Record</span>
          <span className="text-xs text-white/40">© {new Date().getFullYear()} World Entertainment Institute. Demo data shown for illustration.</span>
        </div>
      </div>
    </footer>
  );
}
